module.exports = __webpack_public_path__ + "img/huan.5a77e283.jpg";